exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkbox-label{display:inline-block\n}\n.checkbox-label .checkbox{display:inline-block\n}\n.checkbox-label .checkbox .wei-Font-radio{vertical-align:-0.06rem\n}\n.checkbox-label .checkbox .wei-Font-radio:before{content:\"\\EA06\";font-size:.34rem\n}\n.checkbox-label .checkbox .checkbox-icon{color:#3b8dfb\n}\n.checkbox-label .checkbox .uncheckbox-icon{color:#bbb\n}\n.checkbox-label .checkbox input:checked+.checkbox-icon::after{background-color:#3f8ffd;opacity:1\n}\n.checkbox-label input{position:absolute;left:-9999px\n}\n.checkbox-label.disabled .checkbox-icon{color:#bbb\n}", ""]);

// exports
